/* eslint-disable */
import { initEmptySeoTemplate } from "@components/HeadSeo/emptyTemplate";

export const EDITABLE_LINK_VARIANTS = {
  forward: "forward",
  back: "back",
};

import {
  commonBlocksOptions,
  specificBlockOptions,
} from "@components/cmsBlocks/configs";
import { createBlockByName } from "@components/cmsBlocks/getBlockTemplate";

export const getTemplatePageData = (blocks = []) => ({
  title: "",
  slug: "",
  isPublished: false,
  hidden: false,
  seo: initEmptySeoTemplate,
  pageData: {
    blocks,
  },
});

export const getAdminTemplatePage = (locales, type, blocks) => {
  const languages = locales.reduce((result, locale) => {
    result[locale] = getTemplatePageData(blocks);

    return result;
  }, {});

  return {
    type,
    languages,
    isPublished: false,
    hidden: false,
    properties: {},
  };
};

export const getAdminTemplateNewPage = (lang, type, blocks) => {
  return {
    type,
    data: {
      [lang]: {
        ...getTemplatePageData(blocks),
      },
    },
    isPublished: false,
    hidden: false,
    properties: {},
  };
};

const pageFolderName = {
  news: "news",
  story: "stories",
  promo: "promo",
  destination: "destinations",
  route: "routes",
  faq: "faq",
};

export const getPageFolderName = (likeArray) => {
  return likeArray ? Object.values(pageFolderName) : pageFolderName;
};

const pageTypes = {
  regular: "regular",
  route: "route",
  destination: "destination",
  news: "news",
  story: "story",
  promo: "promo",
  faq: "faq",
};

export const getPageTypes = (likeArray) => {
  return likeArray ? Object.values(pageTypes) : pageTypes;
};

export const defaultPageBlocks = {
  regular: [
    createBlockByName("hero", {
      specific: {
        showSearch: {
          value: false,
        },
      },
    }),
  ],
  news: [
    createBlockByName("hero", {
      specific: {
        subTitleType: {
          value: specificBlockOptions.hero.subTitleType.options[2].value,
        },
        showSearch: {
          value: false,
        },
      },
    }),
    createBlockByName("content", {
      common: {
        blockType: {
          value: commonBlocksOptions.blockType.options[2].value,
        },
      },
      specific: {
        columns: {
          value: specificBlockOptions.content.columns.options[0].value,
        },
        component: {
          value: specificBlockOptions.content.component.options[1].value,
        },
        componentContentType: {
          value:
            specificBlockOptions.content.componentContentType.options[0].value,
        },
        componentPosition: {
          value:
            specificBlockOptions.content.componentPosition.options[1].value,
        },
        showShareButtons: {
          value: true,
        },
      },
    }),
    // createBlockByName("news", {
    //   common: {
    //     blockType: {
    //       value: commonBlocksOptions.blockType.options[2].value,
    //     },
    //   },
    // })
  ],
  promo: [createBlockByName("hero"), createBlockByName("promo")],
  story: [
    createBlockByName("hero", {
      specific: {
        subTitleType: {
          value: specificBlockOptions.hero.subTitleType.options[2].value,
        },
        showSearch: {
          value: false,
        },
      },
    }),
    createBlockByName("content", {
      common: {
        blockType: {
          value: commonBlocksOptions.blockType.options[2].value,
        },
      },
      specific: {
        columns: {
          value: specificBlockOptions.content.columns.options[0].value,
        },
        component: {
          value: specificBlockOptions.content.component.options[1].value,
        },
        componentContentType: {
          value:
            specificBlockOptions.content.componentContentType.options[1].value,
        },
        componentPosition: {
          value:
            specificBlockOptions.content.componentPosition.options[1].value,
        },
        showShareButtons: {
          value: true,
        },
      },
    }),
  ],
  route: [
    createBlockByName("hero", {
      specific: {
        subTitleType: {
          value: specificBlockOptions.hero.subTitleType.options[1].value,
        },
        backgroundOption: {
          value: specificBlockOptions.hero.backgroundOption.options[1].value,
        },
      },
    }),
    createBlockByName("stops"),
    {
      widgetId: 86,
    },
    {
      widgetId: 73,
    },
    {
      widgetId: 81,
    },
    {
      widgetId: 84,
    },
    // createBlockByName("traveling"), // widget traveling
    // createBlockByName("content"), // widget recomendations
    // createBlockByName("popular"), // wideget popular routes
  ],
  destination: [
    createBlockByName("hero", {
      specific: {
        subTitleType: {
          value: specificBlockOptions.hero.subTitleType.options[1].value,
        },
        backgroundOption: {
          value: specificBlockOptions.hero.backgroundOption.options[1].value,
        },
      },
    }),
    createBlockByName("content", {
      specific: {
        columns: {
          value: specificBlockOptions.content.columns.options[2].value,
        },
        component: {
          value: specificBlockOptions.content.component.options[3].value,
        },
      },
    }),
    createBlockByName("galeryV7", {
      common: {
        blockType: {
          component: "blockType",
          value: commonBlocksOptions.blockType.options[3].value,
        },
      },
    }),
    createBlockByName("popular"), // wideget popular destinations

    // createBlockByName("traveling"),
    // createBlockByName("popular", {
    //   specific: {
    //     contentType: {
    //       value: specificBlockOptions.popular.contentType.options[1].value,
    //     },
    //   },
    // }),
  ],
  faq: [
    createBlockByName("hero", {
      specific: {
        showSearch: {
          value: false,
        },
      },
    }),
  ],
};

export const getDefaultPageBlocks = (type) => {

  if (defaultPageBlocks[type]) {
    return defaultPageBlocks[type];
  }

  return [createBlockByName("hero", {
    specific: {
      showSearch: {
        value: false,
        },
      },
    }),
  ];
};

export const reservedPages = {
  [pageTypes.regular]: [
    "new-page",
    "tickets",
    "change-tickets",
    "payment",
    "destinations",
    "routes",
    "destination",
    "route",
    "promo",
    "stories",
    "story",
    "news",
    "profile",
    "payment",
    "change-passw",
  ],
  [pageTypes.route]: [],
  [pageTypes.destination]: [],
  [pageTypes.story]: [],
  [pageTypes.promo]: [],
  [pageTypes.news]: [],
  [pageTypes.faq]: [],
};

export const isReservedPage = (path, pageType) => {
  const pages = reservedPages[pageType] || [];
  return pages.some((page) => path.startsWith(`/${page}`));
};

// cms page rules
export const validationPageRules = {
  isUniqueSlug: {
    description: "Fill in the slug field as well as it must be unique.",
  },
  isValidInternalTitle: {
    description: "Fill in the internal title field it should not be blank.",
  },
  isValidTimePublished: {
    description: "Fill in the time published fields.",
  },
};

Object.keys(validationPageRules).forEach((key) => {
  validationPageRules[key].name = key;
});
